<form [formGroup]="reportIncidentTimeForm" (ngSubmit)="submitClaimIncident()">
  <section formGroupName="details">
    <div class="row">
      <div class="column twelve pad-bottom-10">
        <h4 class="heading-sub-section">When did the incident happen?</h4>
      </div>
      <div class="column twelve md-five">
        <!-- <date-picker
        [name]="dateOfIncident"
        [options]="incidentDatePickerOptions"
        [dateFormGroup]="reportIncidentTimeForm.get('details')"
        [dateFormControlName]="'dateOfIncident'"
        [labelText]="'Date'"
        >
      </date-picker> -->
      </div>
      <div class="column seven md-five pad-right-20 md-pad-horizontal-20">
        <ds-form-control-container
          [labelText]="'Time'"
          [labelClass]="'no-float'"
          [control]="detailsGroup.get('timeOfIncident')"
          data-cy="timeOfIncident"
        >
          <input
            type="text"
            id="timeOfIncident"
            placeholder="hh:mm"
            class="fill"
            formControlName="timeOfIncident"
            data-cy="timeOfIncident"
          />
          <ds-form-control-message
            [control]="detailsGroup.get('timeOfIncident')"
          ></ds-form-control-message>
          @if (reportIncidentTimeForm.hasError('invalidFutureTime')) {
            <ds-form-control-message [control]="reportIncidentTimeForm"></ds-form-control-message>
          }
        </ds-form-control-container>
      </div>
      <div class="column five md-two">
        <ds-form-control-container
          [labelText]="'AM/PM'"
          [control]="detailsGroup.get('amPmSelection')"
          data-cy="amPmSelector"
        >
          <select
            class="icon fill"
            id="amPmSelection"
            data-cy="amPmSelector"
            formControlName="amPmSelection"
          >
            <option value="" selected disabled></option>
            <option value="AM">AM</option>
            <option value="PM">PM</option></select
          ><span class="icon-chevron-down"></span>
          <ds-form-control-message
            [control]="detailsGroup.get('amPmSelection')"
          ></ds-form-control-message>
        </ds-form-control-container>
      </div>
    </div>

    <div class="row callToAction">
      <div class="column twelve">
        <a
          href="javascript:void(0)"
          (click)="goBackOneStep()"
          class="float-right md-float-left caption"
          ><i class="icon-chevron-left"></i> Back</a
        >
        <span class="md-float-right">
          <a class="pad-horizontal-20 caption" (click)="cancel()">Cancel</a>
          <button ds-button type="submit" [disabled]="!reportIncidentTimeForm.valid">
            {{ !!this.draftClaim && !!this.draftClaim?.lossDate ? 'Update' : 'Save and Continue' }}
          </button>
        </span>
      </div>
    </div>
  </section>
</form>
